import { createInstance } from "@shuttlerock/i18n";
import de from "./de.yml";
import en from "./en.yml";
import ja from "./ja.yml";

export const defaultNS = "errorHandling";
export const { i18n, useTranslation, Trans } = createInstance({ en, de, ja }, defaultNS);

i18n.init();

export default i18n;
